import React from 'react';
import { Select, FormControl, MenuItem, Box, InputLabel } from '@mui/material';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import styles from './filterDropdown.style';

const FilterDropdown = ({
  value = '',
  onChange,
  loading = false,
  label = '',
  id = 'select',
  ...props
}) => {
  const _handleOnChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  const getIsSelected = (itemValue) => {
    if (value === null || value === undefined || value === '') {
      return itemValue === null || itemValue === undefined || itemValue === '';
    }
    if (itemValue === null || itemValue === undefined || itemValue === '') {
      return false;
    }
    return itemValue.toString() === value.toString();
  };

  return (
    <FormControl
      variant="outlined"
      sx={{ m: 0, width: props?.width || '100%' }}
    >
      <Box sx={styles.wrapper}>
        <InputLabel>{label}</InputLabel>
        <Select
          data-testid={`input-${id}`}
          label={label}
          variant="outlined"
          sx={{ ...styles.textfield, ...(value && styles.textfieldWithValue) }}
          defaultValue={props.defaultValue || ''}
          size="small"
          value={value}
          disabled={props.disabled || loading}
          onChange={_handleOnChange}
          error={props.error}
          MenuProps={{
            PaperProps: {
              sx: {
                borderRadius: '8px',
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                overflow: 'hidden',
                '& ul': {
                  overflowX: 'auto',
                  maxHeight: '300px',
                  padding: '4px',
                },
              },
            },
          }}
        >
          {props?.options?.map((item) => {
            const isSelected = getIsSelected(item.value);
            return (
              <MenuItem
                key={`${props.label}-${item.text}`}
                sx={styles.menuItem}
                disabled={item.disabled}
                value={item.value}
              >
                {isSelected ? (
                  <CheckCircleIcon sx={styles.radioIcon} />
                ) : (
                  <RadioButtonUncheckedIcon sx={styles.radioUncheckedIcon} />
                )}
                {item.text}
              </MenuItem>
            );
          })}
        </Select>
      </Box>
    </FormControl>
  );
};

export default FilterDropdown;
